export default {
  container: {},
};



// WEBPACK FOOTER //
// ./src/components/Search/styles.js